import styled from '@emotion/styled';
import { Avatar } from '@mui/material';

import { white } from '../../../theme/videa-style-tokens';

export const VideaAvatar = styled(Avatar)<{ background: string }>`
  font-family: 'proxima-nova', sans-serif;
  font-size: 0.75em;
  width: 2em;
  height: 2em;
  background-color: ${({ background }) => background};

  &.MuiChip-avatar {
    color: ${white};
    font-size: 1.5em;
  }
  &.provider {
    font-size: 0.875em;
    padding: 0.05em;
  }
  &.small-count {
    font-size: 0.875em;
    font-weight: 600;
    line-height: 1.5em;
    width: 1.375em;
    height: 1.375em;
    border-radius: 0.375em;
  }
  &.review {
    font-size: 0.625em;
  }
`;
